/** This script was auto generated by 'TypeValidatorCreator' at 'src/infrastructure/scripts/Typescript/TypeValidator.ts' **/
import { createValidator } from '../schema'
import type { SerializedAuthenticationInformation } from './AuthenticationPersistence'
import type { UnknownWebStorageSerializedWrappedValue } from './Base'
import type { AllSerializedCustomTables } from './TablePersistence'
import type { CompressedPersistedTopics } from './TopicsPersistence'

const CompressedPersistedTopicsSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/CompressedPersistedTopics',
    definitions: {
        CompressedPersistedTopics: {
            type: 'object',
            properties: {
                allTopics: { type: 'array', items: { type: 'string' } },
                custom: { type: 'array', items: { type: 'number' } },
                selected: { type: 'array', items: { type: 'number' } },
            },
            required: ['allTopics', 'custom', 'selected'],
            additionalProperties: false,
        },
    },
}
export const isCompressedPersistedTopics = createValidator<CompressedPersistedTopics>(CompressedPersistedTopicsSchema, 'isCompressedPersistedTopics')
const AllSerializedCustomTablesSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/AllSerializedCustomTables',
    definitions: {
        AllSerializedCustomTables: { $ref: '#/definitions/ReadonlyRecord%3Cstring%2Calias-2057045733-350-649-2057045733-0-3257%3E' },
        'ReadonlyRecord<string,alias-2057045733-350-649-2057045733-0-3257>': {
            type: 'object',
            additionalProperties: {
                type: 'array',
                minItems: 4,
                items: [
                    { type: 'number', title: 'page' },
                    { type: 'number', title: 'pageSize' },
                    {
                        anyOf: [
                            { type: 'array', minItems: 2, items: [{ type: 'string' }, { type: 'number' }], maxItems: 2 },
                            { type: 'number', const: 0 },
                        ],
                        title: 'sort',
                    },
                    { type: 'string', title: 'search' },
                ],
                maxItems: 4,
            },
        },
    },
}
export const isAllSerializedCustomTables = createValidator<AllSerializedCustomTables>(AllSerializedCustomTablesSchema, 'isAllSerializedCustomTables')
const SerializedAuthenticationInformationSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/SerializedAuthenticationInformation',
    definitions: {
        SerializedAuthenticationInformation: {
            type: 'array',
            minItems: 4,
            items: [
                { type: 'string', description: 'The auth token' },
                { type: 'string', description: 'The source of the token' },
                { type: 'number' },
                { type: 'array', items: { $ref: '#/definitions/Capability' }, description: 'The capabilities the user has on the application' },
            ],
            maxItems: 4,
        },
        Capability: {
            type: 'string',
            enum: [
                'AGENTS_MANAGE',
                'AGENTS_READ',
                'CONNECTION_READ',
                'CONNECTIONS_MANAGE',
                'CONNECTIONS_READ',
                'CORE_CONTAINER_READ',
                'CORE_CONTAINERS_MANAGE',
                'CORE_CONTAINERS_READ',
                'SERVICE_CONTAINER_READ',
                'SERVICE_CONTAINERS_MANAGE',
                'SERVICE_CONTAINERS_READ',
                'ENDPOINT_READ',
                'ENDPOINTS_MANAGE',
                'ENDPOINTS_READ',
                'MAPPING_READ',
                'MAPPINGS_MANAGE',
                'MAPPINGS_READ',
                'NODES_READ',
                'SERVER_READ',
                'SERVERS_MANAGE',
                'SERVERS_READ',
                'SERVICE_READ',
                'SERVICE_COMMISSIONING_FILE_READ',
                'SERVICES_MANAGE',
                'SERVICES_PARAMETERS_READ',
                'SERVICES_CREATE_OR_UPDATE',
                'SERVICES_READ',
                'SERVICES_CATALOG_READ',
                'SERVICE_SUBSCRIPTION_METADATA',
                'DEVIATIONS_READ',
                'VOLUME_READ',
                'VOLUMES_MANAGE',
                'VOLUMES_READ',
                'MANAGE_USERS',
                'MANAGE_ROLES',
                'MANAGE_PERMISSIONS',
                'CLIENT_REGISTRY_MANAGE',
                'CERTIFICATES_MANAGE',
                'USER_MANAGEMENT_CONFIGURATION',
                'TOPIC_CHUNKS_READ',
                'RULE_ENGINE_RESOURCES',
                'TOPICS_SUBSCRIPTION',
                'WORKBENCH',
                'LOGS_READ',
                'MINIMUM',
                'USE_MFA',
                'SYSTEM_LICENSE_MANAGE',
                'SYSTEM_METRICS_MANAGE',
                'SYSTEM_METRICS_READ',
                'MANAGE_OWN_PASSWORD',
                'RETRIEVE_USERNAME_POLICY',
                'RETRIEVE_PASSWORD_POLICY',
            ],
        },
    },
}
export const isSerializedAuthenticationInformation = createValidator<SerializedAuthenticationInformation>(
    SerializedAuthenticationInformationSchema,
    'isSerializedAuthenticationInformation'
)
const UnknownWebStorageSerializedWrappedValueSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/UnknownWebStorageSerializedWrappedValue',
    definitions: {
        UnknownWebStorageSerializedWrappedValue: {
            type: 'array',
            minItems: 2,
            items: [{ type: 'string', title: 'version' }, { title: 'containedValue' }],
            maxItems: 2,
        },
    },
}
export const isUnknownWebStorageSerializedWrappedValue = createValidator<UnknownWebStorageSerializedWrappedValue>(
    UnknownWebStorageSerializedWrappedValueSchema,
    'isUnknownWebStorageSerializedWrappedValue'
)
